import React from "react";
import parse from "html-react-parser";
import { Alert, AlertIcon } from "@chakra-ui/react";
const Alertment = ({ message }) => {
  return (
    <Alert status="success" marginTop="2%">
      <AlertIcon />
      {parse(message)}
    </Alert>
  );
};
export default Alertment;
